import { apiGet } from 'utils/API/actions/request'
import { GET_COMPANY_INFORMATIONS } from '../constants'

export const getCompanyInformations = (appId, unityId) => apiGet({
  entity: GET_COMPANY_INFORMATIONS,
  url: `/company/${appId}/${unityId}`,
  isChainable: true
})
